export const InputTypes = {
  textInput: "textInput",
  numberInput: "numberInput",
  normalNumber: "normalNumber",
  radioButton: "radio",
  checkbox: "checkbox",
  select: "select",
  textarea: "textarea",
  mobileNumber: "mobileNumber",
  date: "date",
  file: "file",
  year: "year",
};
export const TextInputType = {
  text: "text",
  email: "email",
  number: "number",
  password: "password",
};
export let languagesIds = {
  ar: "Qnc9PQ==",
  en: "QkE9PQ==",
};

export const ResourceTypes = {
  PLATFORM: "platform",
  PROJECT: "project",
  CAMPAIGN: "campaign",
};

export const SuccessStoryMediaTypes = {
  IMAGE: "Image",
  VIDEO: "Video",
};

export const ResourceStatus = {
  IN_PROGRESS: "InProgress",
  COMPLETED: "Completed",
  PENDING: "Pending",
  PAUSED: "Paused",
};

export const FilterValues = {
  ALL: "all",
};

export const SortOptions = {
  NEWEST: "newest",
  OLDEST: "oldest",
  NAME_ASC: "name-asc",
  NAME_DESC: "name-desc",
};

// Donor auth
export const AuthIdentityType = {
  Email: "Email",
};

export const AuthGrantType = {
  Password: "Password",
  RefreshToken: "RefreshToken",
};